/**
 * Team picker enhancer — suggestion dropdown + typewriter placeholder for the bundle builder.
 *
 * Deliberately does NOT touch the engine (`bundle-builder.js`). The engine already
 * listens for clicks on `[data-bb-brandbtn]` and filters the grid itself, so this
 * module only draws extra UI and then delegates by clicking the matching grid button.
 * That way an engine upgrade cannot break the picker.
 *
 * The "Popular" chips and the Clear/Go buttons are plain section markup — the engine
 * already handles those natively.
 */
(function () {
  'use strict';

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /** 0 = matches the start, 1 = matches a word start, 2 = matches mid-string, 3 = no match. */
  function matchScore(text, q) {
    var t = (text || '').toLowerCase();
    if (t.indexOf(q) === 0) return 0;
    var words = t.split(/[\s/&,-]+/);
    for (var i = 0; i < words.length; i++) if (words[i].indexOf(q) === 0) return 1;
    return t.indexOf(q) >= 0 ? 2 : 3;
  }

  function highlight(text, q) {
    var i = (text || '').toLowerCase().indexOf((q || '').toLowerCase());
    if (i < 0 || !q) return esc(text);
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  }

  var TAG_SVG =
    '<svg class="bb-branddrop__ic" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';

  function enhance(picker) {
    if (picker.dataset.bbPickerReady) return;
    picker.dataset.bbPickerReady = '1';

    var input = picker.querySelector('[data-bb-brandfilter]');
    var drop = picker.querySelector('[data-bb-branddrop]');
    var grid = picker.querySelector('[data-bb-brandgrid]');
    var clear = picker.querySelector('[data-bb-brandclear]');
    if (!input || !grid) return;

    var teams = [].map.call(grid.querySelectorAll('[data-bb-brandbtn]'), function (btn) {
      return { name: btn.dataset.brand || '', img: btn.dataset.img || '', btn: btn };
    });
    if (!teams.length) return;

    var goLabel = (drop && drop.dataset.goLabel) || 'Choose';
    var noneLabel = (drop && drop.dataset.noneLabel) || 'No team matches';

    function closeDrop() {
      if (!drop) return;
      drop.classList.remove('bb-open');
      drop.innerHTML = '';
    }

    function renderDrop(q) {
      if (!drop) return;
      var query = (q || '').trim().toLowerCase();
      if (!query) return closeDrop();
      var matches = teams
        .map(function (t) { return { t: t, s: matchScore(t.name, query) }; })
        .filter(function (x) { return x.s <= 2; })
        .sort(function (a, b) { return a.s - b.s; })
        .slice(0, 8);
      if (!matches.length) {
        drop.innerHTML = '<div class="bb-branddrop__none">' + esc(noneLabel) + ' “' + esc(q) + '”.</div>';
        drop.classList.add('bb-open');
        return;
      }
      drop.innerHTML = matches
        .map(function (x, i) {
          return '<button type="button" class="bb-branddrop__opt' + (i === 0 ? ' bb-active' : '') +
            '" data-bb-drop-opt data-brand="' + esc(x.t.name) + '" role="option">' +
            (x.t.img ? '<img class="bb-branddrop__logo" loading="lazy" decoding="async" src="' + esc(x.t.img) + '" alt="">' : TAG_SVG) +
            '<span class="bb-branddrop__name">' + highlight(x.t.name, query) + '</span>' +
            '<span class="bb-branddrop__go">' + esc(goLabel) + ' →</span></button>';
        })
        .join('');
      drop.classList.add('bb-open');
    }

    function opts() {
      return drop ? [].slice.call(drop.querySelectorAll('[data-bb-drop-opt]')) : [];
    }
    function moveActive(dir) {
      var list = opts();
      if (!list.length) return;
      var cur = -1;
      list.forEach(function (o, i) { if (o.classList.contains('bb-active')) cur = i; });
      cur += dir;
      if (cur < 0) cur = list.length - 1;
      if (cur >= list.length) cur = 0;
      list.forEach(function (o, i) { o.classList.toggle('bb-active', i === cur); });
      list[cur].scrollIntoView({ block: 'nearest' });
    }
    /** Delegate to the engine: click the matching grid button instead of handling selection here. */
    function pick(name) {
      var hit = teams.filter(function (t) { return t.name === name; })[0];
      closeDrop();
      if (hit) hit.btn.click();
    }
    function pickActive() {
      var list = opts();
      if (!list.length) return false;
      var active = list.filter(function (o) { return o.classList.contains('bb-active'); })[0] || list[0];
      pick(active.dataset.brand);
      return true;
    }
    /** Enter with no dropdown open -> take the first still-visible button in the grid. */
    function jumpFirst() {
      var first = grid.querySelector('[data-bb-brandbtn]:not([hidden])');
      if (first) first.click();
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      renderDrop(q);
      if (clear) clear.hidden = !q;
    });
    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q) renderDrop(q);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(-1); }
      else if (e.key === 'Enter') { e.preventDefault(); if (!pickActive()) jumpFirst(); }
      else if (e.key === 'Escape') { e.stopPropagation(); closeDrop(); }
    });
    if (drop) {
      drop.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-bb-drop-opt]');
        if (opt) pick(opt.dataset.brand);
      });
    }
    var go = picker.querySelector('[data-bb-brandgo]');
    if (go) go.addEventListener('click', function () { if (!pickActive()) jumpFirst(); });
    if (clear) {
      clear.addEventListener('click', function () {
        // Trước đây chỉ đóng dropdown rồi tự ẩn, KHÔNG xoá chữ trong ô -> nút "Clear"
        // không clear gì cả, mà lại biến mất nên khách không bấm lại được.
        input.value = '';
        closeDrop();
        clear.hidden = true;
        input.focus();
      });
    }
    document.addEventListener('click', function (e) {
      if (!picker.isConnected) return;
      if (e.target.closest && e.target.closest('.bb-brandfilter-wrap')) return;
      closeDrop();
    });
  }

  /** Typewriter placeholder: nudges shoppers to type a team name instead of scrolling 32 buttons. */
  function startTypewriter() {
    var inputs = [].slice.call(document.querySelectorAll('[data-bb-brandfilter]'));
    if (!inputs.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var seed = inputs[0].closest('[data-bb-brandpicker]');
    var chips = seed ? [].map.call(seed.querySelectorAll('.bb-brandchip'), function (c) { return c.dataset.brand; }) : [];
    if (!chips.length && seed) {
      chips = [].slice.call(seed.querySelectorAll('[data-bb-brandbtn]'), 0, 8).map(function (b) { return b.dataset.brand; });
    }
    var words = chips.filter(Boolean).slice(0, 8);
    if (!words.length) return;

    var wi = 0, ci = 0, deleting = false;
    function tick() {
      var live = [].slice.call(document.querySelectorAll('[data-bb-brandfilter]'));
      if (!live.length) return;
      var w = words[wi], delay;
      if (!deleting) {
        ci++;
        if (ci >= w.length) { deleting = true; delay = 1200; } else delay = 100;
      } else {
        ci--;
        if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; delay = 280; } else delay = 45;
      }
      var ph = 'Try “' + w.slice(0, ci) + '”';
      live.forEach(function (inp) {
        var idle = document.activeElement !== inp && !inp.value;
        inp.setAttribute('placeholder', idle ? ph : (inp.dataset.phBase || ''));
      });
      setTimeout(tick, delay);
    }
    inputs.forEach(function (inp) { inp.dataset.phBase = inp.getAttribute('placeholder') || ''; });
    setTimeout(tick, 700);
  }

  function boot() {
    var pickers = document.querySelectorAll('[data-bb-brandpicker]');
    if (!pickers.length) return;
    [].forEach.call(pickers, enhance);
    startTypewriter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor re-renders the section -> re-attach (enhance() is idempotent).
  document.addEventListener('shopify:section:load', boot);
})();
